var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: { disabled: _vm.disabled, clearable: "" },
      on: { change: _vm.valueChange },
      model: {
        value: _vm.dataValue,
        callback: function ($$v) {
          _vm.dataValue = $$v
        },
        expression: "dataValue",
      },
    },
    _vm._l(_vm.options, function (item) {
      return _c("el-option", {
        key: item.type_id,
        attrs: {
          label: item.name,
          value: item.type_id,
          disabled: item.is_display !== 1,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }